/* eslint-disable import/prefer-default-export */

import { createContext } from 'react';

export const StepTitleContext = createContext();
export const FlowGettersContext = createContext();
export const FlowSettersContext = createContext();
